<template>
  <search
    ref="search"
    class="card-search"
    source="cards"
    sort="numSales"
    :include-hidden="includeHidden"
    v-bind="$attrs"
    :placeholder="placeholder"
    v-on="$listeners"
  >
    <template #default="slotProps">
      <card-list-item :card="slotProps.item" :fields="['currentValue']" />
    </template>
  </search>
</template>

<script>
import Search from '@/components/Search';

import CardListItem from '@cardladder/shared/components/CardListItem';

export default {
  components: {
    Search,
    CardListItem,
  },

  props: {
    placeholder: {
      type: String,
      default: 'Search for a card',
    },
    includeHidden: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    focus() {
      this.$refs.search.focus();
    },
  },
};
</script>
